import { useState } from "react";

import { updatePartnerLike } from "@src/api/partner/partner";
import { PartnerType } from "@src/define/partner";
import toast from "@src/utils/toast";
import { waitFor, isExternalUrl, HOSTNAME } from "@src/utils";

export default function usePartnerLike() {
  const [isLoadingUpdateLike, setIsLoadingUpdateLike] = useState<boolean>(false);

  async function updatePartnerLikeFromServer(partnerUuid: string, currentIsLike: boolean) {
    if (isLoadingUpdateLike === true) return;

    setIsLoadingUpdateLike(true);

    try {
      const targetIsLikeState = !currentIsLike;
      await updatePartnerLike(partnerUuid, targetIsLikeState);
    } catch (error) {
      console.error("handleUpdatePortfolioLike", error);
      toast.showErrorSnackbar("오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
    } finally {
      await waitFor(300);
      setIsLoadingUpdateLike(false);
    }
  }

  function showPartnerLikeToast(partnerType: number, currentIsLike: boolean) {
    let likePageUrl = `${HOSTNAME}/my-interest/like/partner?tab=${partnerType}`;
    if (partnerType === PartnerType.Planner) {
      likePageUrl = `${HOSTNAME}/my-interest/like/planner?tab=planner`;
    }

    if (currentIsLike === false) {
      toast.showSnackbar("위시리스트에 추가했습니다.", {
        buttonText: "위시리스트 가기",
        onClick: () => {
          window.location.href = isExternalUrl(likePageUrl);
        },
      });
    } else {
      toast.showSnackbar("위시리스트에서 삭제했습니다.", { isShowClose: true });
    }
  }

  return {
    updatePartnerLikeFromServer,
    showPartnerLikeToast,
  };
}
